<template>
  <div>
    <div v-if="statisticsUserCoupon" class="flex-between" style="width: 100%">
      <div style="width: 40%" class="margin-left-10">
        <el-tabs v-model="active" @tab-click="handleClick">
          <el-tab-pane
            v-for="item in tab"
            :key="item.state"
            :label="item.stateStr + ` (${item.nums})`"
            :value="item.state"
            :name="item.state"
          />
        </el-tabs>
      </div>
    </div>
    <el-table
      :data="records"
      border
      size="mini"
      v-loading="loading"
      element-loading-text="正在加载中～"
    >
      <el-table-column label="优惠券名称" prop="name" align="center">
        <template slot-scope="scope">
          <span
            style="cursor: pointer"
            class="color-mainColor"
            @click="handlePkgView(scope.row.couponId)"
            >{{ scope.row.name }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="优惠金额" prop="discountsMoney" align="center" width="100" />
      <el-table-column label="有效期" prop="expiryTime" align="center" />
      <el-table-column label="领取方式" prop="receiveTypeStr" align="center" width="110" />
      <el-table-column label="券使用状态" prop="stateStr" align="center" width="90" />
      <el-table-column label="订单号" prop="orderNo" align="center">
        <template slot-scope="scope">
          {{ scope.row.orderNo || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="抵扣金额" prop="couponAmount" align="center" width="90" />
    </el-table>
    <div style="display: flex; justify-content: right; margin-right: 20px; margin-top: 20px">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="paginationObj.current"
        :page-size="paginationObj.size"
        background
        layout="prev, pager, next"
        :total="total"
        size="mini"
      />
    </div>
    <pkg-view ref="pkgView" v-if="pkgViewVisible" @refreshDataList="onLoad" />
  </div>
</template>

<script>
  import { userCouponPage } from '@/api'
  import PkgView from '@/views/marketing/components/coupon/coupon-pkg-details'
  export default {
    components: {
      PkgView
    },
    props: {
      coupon: {
        type: Object,
        default: () => {}
      },
      statisticsUserCoupon: {
        type: Object,
        default: () => {}
      },
      mobilePhone: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        records: [],
        total: 0,
        paginationObj: {
          current: 1,
          size: 5
        },
        tab: [],
        loading: false,
        pkgViewVisible: false,
        active: '0'
      }
    },
    mounted() {
      this.records = this.coupon.records || []
      this.total = this.coupon.total || 0
      this.tab = Object.entries(this.statisticsUserCoupon).map(([key, value]) => {
        return {
          nums: value,
          state: key,
          stateStr: key === '1' ? '未使用' : key === '2' ? '已使用' : '已过期'
        }
      })
      this.tab.unshift({
        nums: this.total,
        state: '0',
        stateStr: '全部'
      })
    },
    methods: {
      handleClick(tab) {
        if (tab.name !== '0') {
          this.state = tab.name
        } else {
          this.state = ''
        }
        this.paginationObj.current = 1
        this.getPage()
      },
      handlePkgView(id) {
        this.pkgViewVisible = true
        this.$nextTick(() => {
          this.$refs.pkgView.init(id)
        })
      },
      closeLoading() {
        this.$loading().close()
      },
      previewInvoice(url) {
        location.href = url
      },
      async getPage() {
        this.loading = true
        const params = {
          ...this.paginationObj,
          mobilePhone: this.mobilePhone,
          state: this.state
        }
        const { code, data } = await userCouponPage(params)
        if (code === 0) {
          const { total, records } = data
          this.records = records
          this.total = total
          this.loading = false
        }
      },
      handleCurrentChange(e) {
        this.paginationObj.current = e
        this.getPage()
      }
    }
  }
</script>

<style lang="scss" scoped></style>
